import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type {
  DocumentInfo,
  InvestorDeliveryInfo,
  MessageLevel,
} from "../../../../../../api/types/documentCollectionTypes";
import EmptyDocumentPreview from "../../../../../common/document-preview/EmptyDocumentPreview";
import DocumentCollectionContext from "../../DocumentCollectionContext";
import DocumentDetails from "./DocumentDetails";
import DocumentPreviewWrapper from "./DocumentPreviewWrapper";
import MultiDocumentPreview from "./MultiDocumentPreview";

interface Props {
  messageLevel: MessageLevel;
  documents: DocumentInfo[];
  investor?: InvestorDeliveryInfo;
}

const DocumentPreviewContainer = ({ messageLevel, documents, investor }: Props) => {
  const { investorPortalEnabled } = useDefinedContext(DocumentCollectionContext);

  const hideDetailsTab = !investorPortalEnabled || (messageLevel === "Fund" && investor === undefined);
  // Preview is hidden only where Details replaces it, so the two are never hidden at once.
  const hidePreviewTab = !hideDetailsTab && messageLevel === "Fund" && investor !== undefined;

  return (
    <DocumentPreviewWrapper>
      {documents.length === 0 && <EmptyDocumentPreview text="Select a file to see its preview" />}
      {documents.length === 1 && (
        <DocumentDetails
          messageLevel={messageLevel}
          document={defined(documents[0])}
          investor={investor}
          hidePreviewTab={hidePreviewTab}
          hideDetailsTab={hideDetailsTab}
        />
      )}
      {documents.length > 1 && <MultiDocumentPreview documents={documents} />}
    </DocumentPreviewWrapper>
  );
};

export default DocumentPreviewContainer;
